import { useAdvertsQueryApi } from 'graphql/generated';

export const ProductDetailAdvertBanner: FC = () => {
    const [{ data }] = useAdvertsQueryApi();

    const productAdvert = data?.adverts.find((advert) => advert.positionName === 'productDetail') ?? null;

    if (!productAdvert || !('code' in productAdvert)) {
        return null;
    }

    return (
        <div
            className="my-7 text-small font-medium text-primary"
            dangerouslySetInnerHTML={{ __html: productAdvert.code }}
        />
    );
};
